import React from "react";
import { InputProps, InputWithIconProps } from "../../utils/types";
import { Icon } from "@iconify/react";
import MultiSelectDropdown from "./select";

const Input: React.FC<InputProps> = ({
	name,
	label,
	placeholder,
	footer,
	onChange,
	value,
	readonly = false,
	bg,
	type,
	options,
}) => {
	return (
		<div>
			<div className="form-group">
				<label htmlFor={name} className=" text-sm font-medium text-es-gray-200">
					{label}
				</label>
				{type === "select" ? (
					<>
						<select
							onChange={onChange}
							className="main-shadow mt-2 pl-12 h-full w-full rounded-lg main-border "
							name={name}
							disabled={readonly}
							value={value}>
							<option selected value="">
								Select {placeholder}
							</option>
							{options ? (
								<>
									{options?.map((it, i) => (
										<option key={i} value={it?._id}>
											{it?.title}
										</option>
									))}
								</>
							) : (
								<></>
							)}
						</select>
					</>
				) : (
					<input
						readOnly={readonly}
						type={type || "text"}
						placeholder={placeholder}
						name={name}
						onChange={onChange}
						style={{
							backgroundColor: bg || "transparent",
						}}
						value={value}
						className="main-shadow mt-2 px-3 main-border h-11 w-full bg-transparent"
						// id=""
					/>
				)}
				{footer && (
					<small className="text-sm mt-3 font-normal text-es-gray-100">
						{footer}
					</small>
				)}
			</div>
		</div>
	);
};

export const InputWithIcon: React.FC<InputWithIconProps> = ({
	name,
	label,
	placeholder,
	footer,
	onChange,
	value,
	readonly = false,
	icon,
	type,
	options,
}) => {
	return (
		<div className="form-group">
			<label htmlFor={name} className=" text-sm font-medium text-es-gray-200">
				{label}
			</label>
			<div className="relative h-11 w-full bg-transparent">
				<Icon
					icon={icon}
					color="#667085"
					style={{
						fontSize: "24px",
					}}
					className="absolute top-4 left-3"
				/>
				{type === "select" ? (
					<>
						{/* <select
							onChange={onChange}
							className="main-shadow mt-2 pl-12 h-full w-full rounded-lg main-border "
							name={name}
							disabled={readonly}
							value={value}>
							<option selected value="">
								Select {placeholder}
							</option>
							{options ? (
								<>
									{options?.map((it, i) => (
										<option key={i} value={it?._id}>
											{it?.title}
										</option>
									))}
								</>
								) : (
									<></>
									)}
									</select> */}
						<MultiSelectDropdown
							className="main-shadow pl-12 w-full rounded-lg main-border "
							placeholder={placeholder}
							innerClassName="n"
							// label="Currency"
							options={options?.map(it => {
								return {
									label: it?.title,
									value: it?._id,
								};
							})}
							onChange={sel => {
								onChange({
									target: {
										value: sel,
										name,
									},
								});
							}}
							defaultValue={value}
							defaultType="radio"
						/>
					</>
				) : (
					<input
						readOnly={readonly}
						type={type || "text"}
						placeholder={placeholder}
						name={name}
						onChange={onChange}
						value={value}
						className="main-shadow mt-2 pl-12 h-full w-full rounded-lg main-border "
					/>
				)}
				{footer && (
					<small className="text-sm mt-3 font-normal text-es-gray-100">
						{footer}
					</small>
				)}
			</div>
		</div>
	);
};

export const TextArea: React.FC<InputProps> = ({
  name,
  label,
  placeholder,
  footer,
  onChange,
  value,
  readonly = false,
  bg,
}) => {
  return (
    <div>
      <div className="form-group">
        <label htmlFor={name} className=" text-sm font-medium text-es-gray-200">
          {label}
        </label>
        <textarea
          style={{
            backgroundColor: bg || "transparent",
          }}
          name=""
          readOnly={readonly}
          placeholder={placeholder}
          // onChange={onChange}
          value={value}
          className="main-shadow mt-2 px-3 main-border h-32 pt-5 w-full bg-transparent"
          id=""
        ></textarea>
        {footer && (
          <small className="text-sm mt-3 font-normal text-es-gray-100">
            {footer}
          </small>
        )}
      </div>
    </div>
  );
};

export const SearchInput: React.FC<InputProps> = ({
	placeholder,
	value,
	onChange,
}) => {
	return (
		<>
			<div className="h-11 w-96 relative">
				<input
					className="h-full w-full pl-12 rounded-lg text-base font-normal text-es-gray-100 main-border main-shadow"
					placeholder={placeholder || "Search"}
					required
					type="search"
					name="search"
					id="Search"
					value={value}
					onChange={e => onChange(e.target.value)}
				/>
				<div className="absolute top-3 left-3">
					<Icon
						icon={"si:search-line"}
						style={{
							fontSize: "24px",
						}}
						className="text-es-gray-100"
					/>
				</div>
			</div>
		</>
	);
};

export default Input;
